import {
  SAVE_DAILYTEXTS,
  SAVE_DAILYTEXTS_SUCCESS,
  SAVE_DAILYTEXTS_ERROR
} from "../actions/dailytexts";

const getDailyTextData = ({ dailytexts: { data } }) => data;

const update = ({ user_id, hours: newHours, days: newDays }) => (
  dispatch,
  getState
) => {
  const days = newDays.length ? newDays : newDays.concat(-1); // DO NOT REMOVE HOURS IF NO DAYS SELECTED
  const hours = newHours.length ? newHours : newHours.concat(NaN); // DO NOT REMOVE DAYS IF NO HOURS SELECTED
  const payload = { user_id, hours, days };
  dispatch({ type: SAVE_DAILYTEXTS, payload });
  return fetch(
    `${process.env.REACT_APP_DTDATA_URI}/dts/saveHoursAndDays/${user_id}`,
    {
      method: "POST",
      body: JSON.stringify({ hours, days })
    }
  )
    .then(res => res.json())
    .then(payload => dispatch({ type: SAVE_DAILYTEXTS_SUCCESS, payload }))
    .catch(({ message: payload }) =>
      dispatch({ type: SAVE_DAILYTEXTS_ERROR, payload })
    );
};

export const updateDts = ({ hours, days }) => (dispatch, getState) => {
  const { user_id } = getDailyTextData(getState());

  return update({
    user_id,
    hours,
    days
  })(dispatch, getState);
};

export const setHours = ({ hours }) => (dispatch, getState) => {
  const { user_id, days } = getDailyTextData(getState());

  return update({
    user_id,
    hours,
    days
  })(dispatch, getState);
};

export const createHours = ({ hours: newHours }) => (dispatch, getState) => {
  const { user_id, hours, days } = getDailyTextData(getState());

  return update({
    user_id,
    hours: [].concat(hours).concat(newHours),
    days
  })(dispatch, getState);
};

export const removeHours = ({ hours: oldHours }) => (dispatch, getState) => {
  const { user_id, hours, days } = getDailyTextData(getState());

  return update({
    user_id,
    hours: [].concat(hours).filter(hour => ![].concat(oldHours).includes(hour)),
    days
  })(dispatch, getState);
};

export const setDays = ({ days }) => (dispatch, getState) => {
  const { user_id, hours } = getDailyTextData(getState());

  return update({
    user_id,
    hours,
    days
  })(dispatch, getState);
};

export const createDays = ({ days: newDays }) => (dispatch, getState) => {
  const { user_id, hours, days } = getDailyTextData(getState());

  return update({
    user_id,
    hours,
    days: [].concat(days).concat(newDays)
  })(dispatch, getState);
};

export const removeDays = ({ days: oldDays }) => (dispatch, getState) => {
  const { user_id, hours, days } = getDailyTextData(getState());

  return update({
    user_id,
    hours,
    days: [].concat(days).filter(day => ![].concat(oldDays).includes(day))
  })(dispatch, getState);
};



// WEBPACK FOOTER //
// ./src/store/epics/updateDailyText.js